var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { ActivityAssortedCard } from '../../../common/activity-assorted-card';
import { ActivityEmptyStateCard } from '../../../common/activity-empty-state-card';
import { ActivityMessageBanner } from '../../../common/banners/activity-message-banner';
import { ActivitySpannedTileCard } from './simple-result-card';
import { mapMessageTileToBannerProps } from '../../../common/banners/activity-message-banner-helper';
export var ListLayoutComponent = function (_a) {
  var activityTiles = _a.activityTiles,
    onClick = _a.onClick;
  var getListViewTile = function (activityTile, index) {
    switch (activityTile.__typename) {
      case 'Activity':
        return React.createElement(ActivitySpannedTileCard, {
          key: "acitivity-spanned-tile-card-".concat(activityTile.id),
          activity: activityTile,
          onClick: onClick,
          className: "uitk-card-separator-bottom"
        });
      case 'ActivityMessageTile':
        return React.createElement(UitkSpacing, {
          margin: {
            block: 'six'
          }
        }, React.createElement(ActivityMessageBanner, __assign({}, mapMessageTileToBannerProps(activityTile), {
          key: "acitivity-message-card-".concat(index),
          className: "full-width"
        })));
      case 'ActivityAssortedComponentsTile':
        return React.createElement(ActivityAssortedCard, {
          key: "acitivity-assorted-tile-".concat(index),
          data: activityTile
        });
      case 'ActivityEmptyStateTile':
        return React.createElement(ActivityEmptyStateCard, {
          key: "acitivity-empty-tile-".concat(index),
          data: activityTile
        });
      default:
        return null;
    }
  };
  var renderListViewActivityCard = function () {
    return React.createElement(React.Fragment, null, activityTiles && activityTiles.map(function (activityTile, index) {
      return getListViewTile(activityTile, index);
    }));
  };
  return renderListViewActivityCard();
};